import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 | 爆料直播",
    description: "你访问的页面不存在或已被移除，可返回爆料直播首页，或前往举报通道提交直播争议线索。",
    keywords: "爆料直播,直播举报通道",
    path: location.pathname,
  });

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 lg:px-12 py-32 md:py-40 text-center">
        <p className="font-heading text-6xl md:text-8xl font-bold text-background-300 select-none">404</p>
        <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">页面不存在</h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的地址是 <span className="text-foreground-800">{location.pathname}</span>，它可能已被移除或从未存在。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/report"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium border border-foreground-300 text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            前往举报通道
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}